interface ChoiceMinMaxProps {
  min: number;
  max: number;
}

export const ChoiceMinMax: React.FC<ChoiceMinMaxProps> = ({ min, max }) => {
  const isOptional = min === 0;

  const supportingText = () => {
    if (max === 1) return null;
    if (min === 0 || (min === 1 && max > 1)) return ` - Select up to ${max}`;
    if (min === max) return ` - Select ${max}`;
    return ` - Select at least ${min} and up to ${max}`;
  };

  return (
    <div>
      <strong>{isOptional ? 'Optional' : 'Required'}</strong>
      <span className="text-muted">{supportingText()}</span>
    </div>
  );
};
